


























import DatePicker from 'vue-bootstrap-datetimepicker' // TODO: This package requires 'moment', which has large size
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { DateWithoutHour } from '@/models/date-time/date-without-hour'
import { PluginMixin } from '@spa/mixins/plugin'

@Component({
  components: {
    DatePicker,
  },
})
export default class SelectDeliveryDate extends Mixins<PluginMixin>(
  PluginMixin
) {
  @Prop({ required: true })
  deliverableDates: DateWithoutHour[]

  @Prop({ default: null })
  initialValue: string | null

  deliveryDate: string | null = null

  datepickerOption = {
    locale: 'ja',
    format: 'YYYY/M/DD',
    useCurrent: 'day',
    minDate: new Date(),
    maxDate: new Date(),
    dayViewHeaderFormat: 'YYYY年 MM月',
    ignoreReadonly: true,
  }

  get ascDeliverableDates(): DateWithoutHour[] {
    return this.deliverableDates.sort((a, b) => {
      return a.valueWithNormalizedHour.getTime() - b.valueWithNormalizedHour.getTime()
    })
  }

  @Watch('deliverableDates')
  setDeliverablePeriod() {
    this.datepickerOption.minDate = this.ascDeliverableDates[0].valueWithNormalizedHour
    this.datepickerOption.maxDate =
      this.ascDeliverableDates[this.ascDeliverableDates.length - 1].valueWithNormalizedHour
  }

  created() {
    this.setDeliverablePeriod()
    this.deliveryDate = this.initialValue
  }

  onChange() {
    if (this.deliveryDate === null || this.deliveryDate === '') {
      throw new Error('deliveryDate cannot be changed to null nor empty value.')
    }

    this.changeDeliveryDate(
      DateWithoutHour.create(this.deliveryDate)
    )
  }

  @Emit('change-delivery-date')
  changeDeliveryDate(_d: DateWithoutHour) {
    // do nothing
  }

}
